module.exports = __webpack_public_path__ + "img/tc_3.cf3352ee.jpg";